export default {
  template: {
    label: '模板资产',
    describe: '自定义创意模板',
    create: '空白制作',
    publicVideo: '公共视频模板',
    publicVideoTitle: '新建模板-公共视频模板',
    production: '新建模板',
    filter: {
      templateId: '模板ID',
      state: '送审状态',
      unExamine: '未送审',
      examine: '已送审',
      review: '渲染中',
      reviewFailed: '渲染失败',
      approved: '审核通过',
      refuse: '审核拒绝',
      groundStatus: '上架状态',
      unGround: '未上架',
      ground: '已上架',
      grounding: '上架中',
      groundFail: '上架失败',
      grounded: '已下架',
      replaceMaterial: '素材替换',
      support: '支持',
      unSupport: '不支持',
      templateType: '模板类型',
      commonTemplate: '布局模板',
      contentTemplate: '创意模板',
      templateLabel: '模板标签',
    },
    table: {
      label: '模板名称及ID',
      size: '比例',
      chineseRules: '模板中文名称不能为空',
      enRules: '模板英文名称不能为空',
      delete: '删除模板',
      deleteLabel: '确认删除模板「{name} ｜ {name_en}」吗？',
      unRename: '上架中或已上架的模板不支持重命名',
      unDelete: '上架中或已上架的模板不支持删除',
    },
    dialog: {
      common: '布局',
      content: '创意',
    },
  },
}
